import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import StarlitMusicWebsite from "./App"; // file App.js của bạn

export default function RouterApp() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<StarlitMusicWebsite />} />
      </Routes>
    </BrowserRouter>
  );
}
